/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { AuthProvider } from "./hooks/useAutoLogout";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import { useCompanyBranding } from "./hooks/useCompanyBranding";
import useAutoLogout from "./hooks/useAutoLogout";
import LoanDocuments from "./Loan/LoanDocuments";



import Dashboard from "./pages/Dashboard";
import CustomerList from "./pages/Customers";
import CustomerForm from "./pages/CustomerForm";
import CustomerKyc from "./pages/CustomerKyc.jsx";
import HrModule from "./pages/HrModule";
import LeaveForm from "./pages/LeaveForm";
import Holiday from "./pages/Holiday";
import EmployeeAttendance from "./pages/EmployeeAttendance";
import ProfilePage from "./pages/Profile";

import UpdatePasswordTable from './pages/UpdatePassword';
import Contact from './pages/Contact';

import OpenAccount from './Banking/OpenAccount';
import FixedDepositForm from './Banking/Fixed';
import RecurringDepositForm from './Banking/Recurring';
import SavingAccountForm from './Banking/Savings';
import VerifyAccount from './Banking/VerifyAccount';
import ReportPage from './Banking/ReportPage';
import FdMisReport from './Banking/FdMisReport';
import SavingAccountReport from './Banking/SavingAccountReport';
import MakeMisPayment from './Banking/MakeMisPayment';
import CloseAccount from './Banking/CloseAccount';

import Sidebar from './components/Sidebar';
import Header from './components/Header';

import RequestWalletFund from './wallet/RequestWalletFund';
import PayInstallments from './transactions/PayInstallments';
// import CollectionReport from './transactions/CollectionReport';
import PayDueAmount from './transactions/PayDueAmount';
import PersonalLoanForm from './Loan/PersonalLoanForm';
import CcLoanForm from './Loan/CcLoanForm';
import EmiLoanForm from './Loan/EmiLoanForm';
import LoanKyc from './Loan/LoanKyc';
import LoanReport from './Loan/LoanReport';
import DueEmiManagement from './Loan/DueEmiManagement';
import LoanCollectionReport from './Loan/LoanCollectionReport';
import LoanEmiCalculator from './Loan/EmiCalculator';
import PrintLoan from './print/LoanLetter';

import Login from './components/Login';

import "./assets/css/style.css";
import "./assets/css/responsive.css";
import CustomerReport from "./pages/CustomerReport";
import NomineeManagement from "./pages/nominee_detail";
import LoanKycDetails from "./Loan/LoanKycDetails";
import GroupCenter from "./GroupLoan/GroupCenter";
import GroupCollectionReport from "./GroupLoan/Collectionreport";
import GroupLoanStatus from "./GroupLoan/groupLoanStatus";
import EmiDueReportGroup from "./GroupLoan/groupEmi";
import EmiDueReport from "./Loan/EmiDueReport";
import CollectionReport from "./Loan/CollectionReport";

import EmiDueReportMember from "./GroupLoan/emiDueReportMember";
// import GroupMembers from './GroupLoan/GroupMembers';
import GroupCreate from './GroupLoan/GroupCreate';
import GroupLoanReport from './GroupLoan/GroupLoanReport';
import GroupLoanEmiCard from "./GroupLoan/GroupLoanEmiCard";
import GroupLoanApplicationForm from "./GroupLoan/GroupLoanApplicationForm";
import GroupLoanEmiDetails from "./GroupLoan/GroupLoanEmiDetails";
import GroupLoanEmiDetailsReciept from "./GroupLoan/GroupLoanEmiDetailsReciept";
import GroupLoanScheme from './GroupLoan/GroupLoanScheme';
import Groups from './GroupLoan/Groups';
import Area from './GroupLoan/Area';
import Cgt from './GroupLoan/Cgt';
import Grt from './GroupLoan/Grt';
import CgtTraining from './GroupLoan/CgtTraining';
import GrtTraining from './GroupLoan/GrtTraining';
import GroupLoanForm from './GroupLoan/GroupLoanForm';

import GoldLoanApplicationForm from "./Gold Loan/GoldLoanApplicationForm";
import GoldLoanForm from "./Gold Loan/GoldLoanForm"
import GoldLoanReport from './Gold Loan/GoldLoanReport'
import GoldEmiDueReport from './Gold Loan/GoldEmiDueReport'
import GoldCollectionReport from './Gold Loan/GoldCollectionReport'



import LoanEmiDetails from './Loan/LoanEmiDetails';
import LoanEmiCard from './Loan/LoanCard';
import LoanApplicationForm from './Loan/LoanApplicationForm';


// Banking → OpenAccount
import Saving from './Banking/OpenAccount/Saving';
import RDACC from './Banking/OpenAccount/RDACC';
import Current from './Banking/OpenAccount/Current';
import Sanction from './Banking/OpenAccount/Sanction';
import CC from './Banking/OpenAccount/CC';
import ApplyCC from './Banking/OpenAccount/ApplyCC';
import Promises from './Banking/OpenAccount/Promises';
import Agreement from './Banking/OpenAccount/Agreement';
import PaySlip from './Banking/OpenAccount/PaySlip';


// Banking → DepositAccounts
import FD from './Banking/DepositAccount/FD';
import RD from './Banking/DepositAccount/RD';
import DD from './Banking/DepositAccount/DD';
import MIS from './Banking/DepositAccount/MIS';

import DepositEmiList from "./Banking/DepositAccount/depositlistemi";



// Banking → Report

import DDReport from './Banking/Report/DDReport';
import FDReport from './Banking/Report/FDReport';
import Verify from './Banking/Report/Verify';
import SavingReport from './Banking/Report/SavingReport';
import Demo from './Banking/Report/Demo';
import RDReport from './Banking/Report/RDReport';
import Close from './Banking/Report/Close';
import Bond from './Banking/Report/Bond';
import Log from './Banking/Report/Log';

// Banking → Certificate

import RDCertificates from './Banking/Report/RDCertificates';
import FDCertificates from './Banking/Report/FDCertificates';
import DDCertificates from './Banking/Report/DDCertificates';
import MisCertificates from './Banking/Report/MisCertificates';
import DepositInstallmentDueReport from './Banking/DepositAccount/DepositInstallmentDueReport';
import DepositCollectionReport from './Banking/DepositAccount/DepositCollectionReport';
import Membership from './Banking/Report/Membership';
import CustomerCertificates from "./Banking/Report/CustomerCertificates";
import SharesCertificates from "./Banking/Report/SharesCertificates";
import SavingPassbook from "./Banking/Report/SavingPassbook";
import LoanStatement from "./Banking/Report/LoanStatement";

// Banking →Scheme
import FDScheme from './Banking/Scheme/FDScheme';
import RDScheme from './Banking/Scheme/RDScheme';
import SavingScheme from './Banking/Scheme/SavingScheme';
import Share from './Banking/Scheme/Share';
import MISPayment from './Banking/Scheme/MISPayment';
import FDCertificate from './Banking/Scheme/FDCertificate';

import NewCC from './Banking/Scheme/NewCC';
import NewsCC from './Banking/Scheme/NewsCC';


// Accountant
import GroupList from './Accountant/GroupList'
import LedgerList from './Accountant/LedgerList'
import BranchLedgerList from "./Accountant/BranchLedgerList";
import LedgerEntry from './Accountant/LedgerEntry'
import DayBook from './Accountant/Voucher/DayBook'
import CashBook from './Accountant/Voucher/CashBook'
import VoucherEntry from './Accountant/Voucher/VoucherEntry.jsx'
import TrialBalance from './Accountant/Voucher/TrialBalance'
import FyTrialBalance from './Accountant/Voucher/FyTrialBalance'
import FyOpeningBalance from './Accountant/Voucher/FyOpeningBalance'
import VoucherReports from './Accountant/Voucher/VoucherReports'
import FundTransfer from './Accountant/FundTransfer'
import Overview from './Accountant/Overview'
import ProfitLoss from './Accountant/ProfitLoss'


// cibil

import Cibil from './Cibil/EquafixCibil.jsx';
import CibilReport from "./Cibil/EquafixCibilReport.jsx";
import TransactionForm from "./transactions/TransactionForm";
import PrintStatement from "./print/PrintStatement";
import RDDDPassbook from "./Banking/Report/RDDDPassbook";
import AreaSurveyReport from "./GroupLoan/AreaSurvayReport";
import LoanCloserReport from "./Loan/LoanCloserReport";
import LoanCloserRequest from "./Loan/LoanCloserRequest";
import AreaSurveyCenter from "./GroupLoan/AreaSurveyCenter";
import SavingAccountTransaction from "./transactions/SavingAccountTransaction";
import TransactionReport from "./transactions/TransactionReport";
import DemoPassbook from "./transactions/DemoPassbook";
import ViewStatement from "./transactions/ViewStatement";
import SearchCustomer from "./pages/SearchCustomer";
import LoanStatment from "./Loan/LoanStatment";
import WalletTransaction from "./wallet/WalletTransaction";
import Journal from "./Accountant/Voucher/Journal";
import PrintLoanStatement from "./print/PrintLoanStatement";
import GroupLoanEmiDueReport from "./GroupLoan/GroupLoanEmiDueReport";
import GroupLoanCollectionReport from "./GroupLoan/GroupLoanCollectionReport";
import GroupLoancollectionReciept from "./GroupLoan/GroupLoanCollectionReciept"
import LoanClosingNOC from "./Loan/LoanClosingNOC";
import DemandSheet from "./GroupLoan/DemandSheet";
import DemoDashboard from "./transactions/DemoPassbook";
import LoanPassbook from "./Loan/LoanPassbook";
import ViewLoanCollectionReceipt from "./Loan/ViewLoanCollectionReceipt";
import Depositemireciept from "./Banking/DepositAccount/Depositemireciept";
import SavingCloserRequest from "./Banking/Report/SavingCloserRequest";
import RDDDCloserRequest from "./Banking/Report/RDDDCloserRequest";
import FDMISCloserRequest from "./Banking/Report/FDMISCloserRequest";
import DepositCollectionReceipt from "./Banking/DepositAccount/DepositCollectionReceipt";
import Loanemireciept from "./Loan/LoanEmiReciept";
import GoldLoanEmiDetails from "./Gold Loan/GoldLoanEmiDetails";
import VehicleLoanForm from "./VehicleLoan/VehicleLoanForm";
import VehicleLoanReport from "./VehicleLoan/VehicleLoanReport";
import VehicleLoanEmiDetails from "./VehicleLoan/VehicleLoanEmiDetails";
import VehicleEmiDueReport from "./VehicleLoan/VehicleEmiDueReport";
import VehicleCollectionReport from "./VehicleLoan/VehicleCollectionReport";
import GoldLoanEmiDetailsReciept from "./Gold Loan/GoldLoanEmiDetailsReciept";
import GoldLoanEmiCard from "./Gold Loan/GoldLoanEmiCard";
import RDDDAccountTransaction from "./transactions/RDDDAccountTransaction";
import ProductCollectionReport from "./Product Loan/ProductCollectionReport";
import ProductEmiDueReport from "./Product Loan/ProductLoanEmiDueReport.jsx";
import ProductLoanEmiDetails from "./Product Loan/ProductLoanEmiDetails";
import ProductLoanForm from "./Product Loan/ProductLoanForm";
import ProductLoanReport from "./Product Loan/ProductLoanReport";
import LoanPreCloserRequest from "./assets/Loan/LoanPreCloserRequest";
import RDDDPreClosure from "./transactions/RDDDPreClosure";
import RDDDEmiPay from "./transactions/RDDDEmiPay";
import SingleLoanEmiPay from "./Loan/SingleLoanEmiPay";
import SingleLoanEmiReceipt from "./Loan/SingleLoanEmiReceipt";
import LoanSettlementRequest from "./Loan/LoanSettlementRequest";
import ProductLoanEmiCard from "./Product Loan/ProductLoanEmiCard";
import ProductLoanEmiDueReport from "./Product Loan/ProductLoanEmiDueReport.jsx";
import ProductCollectionReciept from "./Product Loan/ProductCollectionReciept.jsx";
import ProductLoanDocuments from "./Product Loan/ProductLoanDocuments.jsx";
import ProductLoanSanction from "./Product Loan/ProductLoanSanction.jsx";
import ProductLoanPromise from "./Product Loan/ProductLoanPromise.jsx";
import ProductLoanAgreement from "./Product Loan/ProductLoanAgreement.jsx";
import MisHistory from "./Banking/Report/MisHistory.jsx";
import AgentDashboard from "./pages/AgentDashboard.jsx";
import FixedLoanForm from "./Loan/FixedLoanForm.jsx";
import GroupFixedLoanForm from "./GroupLoan/GroupFixedLoanForm.jsx";
import BankBook from "./Accountant/Voucher/BankBook.jsx";
import GroupLoanDocuments from "./GroupLoan/GroupLoanDocuments.jsx";
import GroupLoanSanction from "./GroupLoan/GroupLoanSanction.jsx";
import GroupLoanAgreement from "./GroupLoan/GroupLoanAgreement.jsx";
import GroupLoanPromise from "./GroupLoan/GroupLoanPromise.jsx";
import CdsReport from "./GroupLoan/CdsReport.jsx";
import GroupLoanSingleEmiPay from "./GroupLoan/GroupLoanSingleEmiPay.jsx";
import GroupLoanStatement from "./GroupLoan/GroupLoanStatement.jsx";
import GroupLoanCloser from "./GroupLoan/GroupLoanCloser.jsx";
import GroupLoanNOCLetter from "./GroupLoan/GroupLoanNOCLetter.jsx";
import RDDDAlternatePayment from "./Banking/Report/RDDDAlternatePayment.jsx";
import RDDDManualPay from "./transactions/RDDDManualPay.jsx";
import RDDDAlternatePayReceipt from "./Banking/Report/RDDDAlternatePayReceipt.jsx";
import EquafixCibil from "./Cibil/EquafixCibil.jsx";
import ExperianCibil from "./Cibil/ExperianCibil.jsx";
import GroupLoanPassbook from "./GroupLoan/GroupLoanPassbook.jsx";



export default function App() {
  // useAutoLogout();
  const [authenticated, setAuthenticated] = useState(!!localStorage.getItem('authToken'));

  useEffect(() => {
    const checkAuth = () => {
      setAuthenticated(!!localStorage.getItem('authToken'));
    };

    window.addEventListener('storage', checkAuth);
    const interval = setInterval(checkAuth, 1000);

    return () => {
      window.removeEventListener('storage', checkAuth);
      clearInterval(interval);
    };
  }, []);











  const { company, fetchError, loading } = useCompanyBranding();



  if (loading) {
    return <div>Loading...</div>; // you can make this a splash screen
  }




  return (
    <AuthProvider>
    <Router>
      <Routes>
        {/* Root path - redirect to dashboard or login based on auth */}
        <Route path="/" element={<Navigate to={authenticated ? '/dashboard' : '/login'} replace />} />

        {/* Login */}
        <Route
          path="/login"
          element={
            authenticated ? <Navigate to="/dashboard" replace /> : <Login />
          }
        />

        {/* Protected layout */}
        {authenticated ? (
          <Route
            path="/*"
            element={
              <div className="main-wrapper">
                <Sidebar />
                <div className="page-wrapper">
                  <Header />
                  <div className="content">
                    <Routes>
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="/DemoDashboard" element={<DemoDashboard />} />
                      <Route path="/AgentDashboard" element={<AgentDashboard />} />
                      <Route path="customers" element={<CustomerList />} />
                      <Route path="customers/add" element={<CustomerForm />} />
                      <Route path="/Customers/CustomerKyc" element={<CustomerKyc />} />
                      <Route path="/Customers/SearchCustomer" element={<SearchCustomer />} />
                      <Route
                        path="CustomerReport"
                        element={<CustomerReport />}
                      />
                      <Route
                        path="NomineeManagement"
                        element={<NomineeManagement />}
                      />
                      <Route path="HrModule" element={<HrModule />} />
                      <Route path="LeaveForm" element={<LeaveForm />} />
                      <Route path="holiday" element={<Holiday />} />
                      <Route path="EmployeeAttendance" element={<EmployeeAttendance />} />
                      <Route path="profile" element={<ProfilePage />} />

                      <Route path="UpdatePassword" element={<UpdatePasswordTable />} />
                      <Route path="Contact" element={<Contact />} />
                      <Route path="Banking/OpenAccount" element={<OpenAccount />} />
                      <Route path="Banking/OpenAccount/Fixed" element={<FixedDepositForm />} />
                      <Route path="Banking/OpenAccount/Recurring" element={<RecurringDepositForm />} />
                      <Route path="Banking/OpenAccount/Savings" element={<SavingAccountForm />} />
                      <Route path="Banking/VerifyAccount" element={<VerifyAccount />} />
                      <Route path="Banking/ReportPage" element={<ReportPage />} />
                      <Route path="Banking/FdMisReport" element={<FdMisReport />} />
                      <Route path="Banking/SavingAccountReport" element={<SavingAccountReport />} />
                      <Route path="Banking/CloseAccount" element={<CloseAccount />} />
                      <Route path="Banking/MisPayment" element={<MakeMisPayment />} />
                      <Route path="/wallet/WalletTransaction" element={<WalletTransaction />} />
                      <Route path="/wallet/RequestWalletFund" element={<RequestWalletFund />} />
                      <Route path="transactions/PayInstallments" element={<PayInstallments />} />
                      <Route path="transactions/CollectionReport" element={<CollectionReport />} />
                      <Route path="transactions/PayDueAmount" element={<PayDueAmount />} />
                      <Route path="Loan/PersonalLoanForm" element={<PersonalLoanForm />} />
                      <Route path="/Loan/FixedLoanForm" element={<FixedLoanForm />} />
                      <Route path="Loan/CcLoanForm" element={<CcLoanForm />} />
                      <Route path="Loan/EmiLoanForm" element={<EmiLoanForm />} />
                      <Route path="Loan/LoanKyc" element={<LoanKyc />} />
                      <Route path="Loan/LoanReport" element={<LoanReport />} />
                      <Route path="/Loan/LoanStatement" element={<LoanStatment />} />
                      <Route path="/Loan/SingleLoanEmiPay" element={<SingleLoanEmiPay />} />
                      <Route path="/Loan/SingleLoanEmiReceipt" element={<SingleLoanEmiReceipt />} />
                      <Route path="/Loan/LoanCloserReport" element={<LoanCloserReport />} />
                      <Route path="/Loan/LoanCloserRequest" element={<LoanCloserRequest />} />
                      <Route path="/Loan/LoanPreCloserRequest" element={<LoanPreCloserRequest />} />
                      <Route path="/Loan/LoanSettlement" element={<LoanSettlementRequest />} />
                      <Route path="/Loan/LoanClosing/NOCLetter" element={<LoanClosingNOC />} />
                      <Route
                        path="/Loan/LoanDocuments"
                        element={<LoanDocuments />}
                      />
                      <Route
                        path="Loan/CollectionReport"
                        element={<CollectionReport />}
                      />


                      {/* Accountant */}
                      {/* <Route path="/Accountant/GroupList" element={<GroupList/>}/>
                      <Route path="/Accountant/LedgerList" element={<LedgerList/>}/>
                      <Route path="/Accountant/BranchLedgerList" element={<BranchLedgerList/>}/> */}
                      <Route path="/Accountant/LedgerEntry" element={<LedgerEntry />} />
                      <Route path="/Accountant/FundTransfer" element={<FundTransfer />} />
                      <Route path="/Accountant/Overview" element={<Overview />} />
                      <Route path="/Accountant/ProfitLoss" element={<ProfitLoss />} />
                      <Route path="/Accountant/Voucher/DayBook" element={<DayBook />} />
                      <Route path="/Accountant/Voucher/CashBook" element={<CashBook />} />
                      <Route path="/Accountant/Voucher/BankBook" element={<BankBook />} />
                      <Route path="/Accountant/Voucher/VoucherReports" element={<VoucherReports />} />
                      <Route path="/Accountant/Voucher/VoucherEntry" element={<VoucherEntry />} />
                      <Route path="/Accountant/Voucher/Journal" element={<Journal />} />
                      <Route path="/Accountant/Voucher/TrialBalance" element={<TrialBalance />} />
                      <Route path="/Accountant/Voucher/FyTrialBalance" element={<FyTrialBalance />} />
                      <Route path="/Accountant/Voucher/FyOpeningBalance" element={<FyOpeningBalance />} />



                      <Route path="Loan/DueEmiManagement" element={<DueEmiManagement />} />
                      <Route path="Loan/LoanCollectionReport" element={<LoanCollectionReport />} />
                      <Route path="Loan/ViewLoanCollectionReceipt" element={<ViewLoanCollectionReceipt />} />
                      <Route path="Loan/EmiCalculator" element={<LoanEmiCalculator />} />
                      <Route path="Print/LoanLetter" element={<PrintLoan />} />
                      <Route path="Loan/LoanKycDetails/:loanId" element={<LoanKycDetails />} />
                      {/* Group Loan */}
                      {/* <Route path="grouploan/areasurveycenter" element={<AreaSurveyCenter />} /> */}
                      <Route path="/GroupLoan/CenterCreate" element={<GroupCenter />} />
                      {/* <Route path="grouploan/areasurveycenter/groupcenter" element={<GroupCenter />} /> */}

                      <Route path="/GroupLoan/GroupLoanCollectionReport" element={<GroupLoanCollectionReport />} />
                      <Route path="/GroupLoan/GroupLoanCollectionReciept" element={<GroupLoancollectionReciept />} />
                      <Route path="/GroupLoan/Collectionreport" element={<GroupCollectionReport />} />
                      <Route path="/GroupLoan/GroupLoanSingleEmiPay" element={<GroupLoanSingleEmiPay />} />
                      <Route path="/GroupLoan/CdsReport" element={<CdsReport />} />
                      <Route path="grouploan/GroupLoanStatus" element={<GroupLoanStatus />} />
                      <Route path="GroupLoan/GroupLoanCloser" element={<GroupLoanCloser />} />
                      <Route path="GroupLoan/GroupLoanNOCLetter/:loanId" element={<GroupLoanNOCLetter />} />
                      {/* <Route path="/GroupLoan/GroupMembers" element={<GroupMembers />} /> */}
                      <Route path="/GroupLoan/GroupLoanEmiDueReport" element={<GroupLoanEmiDueReport />} />
                      <Route path="/Loan/EmiDueReport" element={<EmiDueReport />} />
                      <Route path="/GroupLoan/EmiDueReportMember" element={<EmiDueReportMember />} />
                      <Route path="/GroupLoan/GroupLoanDocuments" element={<GroupLoanDocuments />} />
                      <Route path="/GroupLoan/GroupLoanSanction/:loanId" element={<GroupLoanSanction/>}/>
                      <Route path="/GroupLoan/GroupLoanPromise/:loanId" element={<GroupLoanPromise/>}/>
                      <Route path="/GroupLoan/GroupLoanAgreement/:loanId" element={<GroupLoanAgreement/>}/>
                      <Route path="/GroupLoan/DemandSheet" element={<DemandSheet />} />
                      <Route path="/GroupLoan/GroupCreate" element={<GroupCreate />} />
                      <Route path="grouploan/grouploanreport" element={<GroupLoanReport />} />
                      <Route path="grouploan/grouploanreport/GroupLoanEmiCard/:loanId" element={<GroupLoanEmiCard />} />
                      <Route path="/GroupLoan/GroupLoanStatement/:loanId" element={<GroupLoanStatement />} />
                      <Route path="/GroupLoan/GroupLoanPassbook/:loanId" element={<GroupLoanPassbook />} />
                      <Route path="grouploan/grouploanreport/GroupLoanEmiDetails/reciept" element={<GroupLoanEmiDetailsReciept />} />
                      <Route path="grouploan/grouploanreport/GroupLoanApplicationForm/:loanId" element={<GroupLoanApplicationForm />} />
                      <Route path="grouploan/grouploanreport/GroupLoanEmiDetails/:loanId" element={<GroupLoanEmiDetails />} />
                      <Route path="grouploan/grouploanscheme" element={<GroupLoanScheme />} />
                      <Route path="/grouploan/groups" element={<Groups />} />
                      <Route path="/grouploan/area" element={<Area />} />
                      <Route path="/GroupLoan/AreaSurvayReport" element={<AreaSurveyReport />} />
                      <Route path="/GroupLoan/AreaSurvayReport/GroupCenter" element={<GroupCenter />} />
                      <Route path="/grouploan/Cgt" element={<Cgt />} />
                      <Route path="/grouploan/Grt" element={<Grt />} />
                      <Route path="/grouploan/CgtTraining" element={<CgtTraining />} />
                      <Route path="/grouploan/GrtTraining" element={<GrtTraining />} />
                      <Route path="/grouploan/GroupLoanForm" element={<GroupLoanForm />} />
                      <Route path="/GroupLoan/GroupFixedLoanForm" element={<GroupFixedLoanForm />} />

                      <Route path="/goldloan/goldLoanForm" element={<GoldLoanForm />} />
                      <Route path="/goldloan/goldloanapplicationform/:loanId" element={<GoldLoanApplicationForm/>} />
                      <Route path="/goldloan/goldLoanReport" element={<GoldLoanReport />} />
                      <Route path="/goldloan/goldEmiDuereport" element={<GoldEmiDueReport />} />
                      <Route path="/goldloan/goldCollectionReport" element={<GoldCollectionReport />} />
                      <Route path="/goldloan/goldLoanReport/goldLoanEmiDetails/:loanId" element={<GoldLoanEmiDetails />} />
                      <Route path="/goldloan/goldLoanReport/goldLoanEmiDetails/reciept" element={<GoldLoanEmiDetailsReciept />} />
                      <Route path="/goldloan/goldLoanReport/goldLoanEmiCard/:loanId" element={<GoldLoanEmiCard />} />

                      <Route path="/vehicleloan/vehicleLoanForm" element={<VehicleLoanForm/>}/>
                      <Route path="/vehicleloan/vehicleLoanReport" element={<VehicleLoanReport/>}/>
                      <Route path="/vehicleloan/vehicleLoanEmiDetails/:loanId" element={<VehicleLoanEmiDetails/>}/>
                      <Route path="/vehicleloan/vehicleEmiDueReport" element={<VehicleEmiDueReport/>} />
                      <Route path="/vehicleloan/vehicleCollectionReport" element={<VehicleCollectionReport/>} />

                      <Route path="/Productloan/ProductLoanForm" element={<ProductLoanForm/>}/>
                      <Route path="/Productloan/ProductLoanReport" element={<ProductLoanReport/>}/>
                      <Route path="/Productloan/ProductCollectionReport" element={<ProductCollectionReport/>} />
                      <Route path="/ProductLoan/ProductCollectionReciept" element={<ProductCollectionReciept/>} />
                      <Route path="/Productloan/ProductLoanEmiDueReport" element={<ProductLoanEmiDueReport/>} />
                      <Route path="/Productloan/ProductLoanDocuments" element={<ProductLoanDocuments/>} />
                      <Route path="/Productloan/ProductLoanEmiDetails/:loanId" element={<ProductLoanEmiDetails/>}/>
                      <Route path="/ProductLoan/ProductLoanEmiCard/:loanId" element={<ProductLoanEmiCard/>}/>
                      <Route path="/ProductLoan/ProductLoanSanction/:loanId" element={<ProductLoanSanction/>}/>
                      <Route path="/ProductLoan/ProductLoanPromise/:loanId" element={<ProductLoanPromise/>}/>
                      <Route path="/ProductLoan/ProductLoanAgreement/:loanId" element={<ProductLoanAgreement/>}/>


                      {/* ✅ New Route - Loan EMI Details */}
                      <Route path="Loan/LoanEmiDetails/:loanId" element={<LoanEmiDetails />} />
                      <Route path="Loan/Loancard/:loanId" element={<LoanEmiCard />} />
                      <Route path="Loan/LoanApplicationForm/:loanId" element={<LoanApplicationForm />} />
                      <Route path="Loan/LoanPassbook/:loanId" element={<LoanPassbook />} />




                      <Route path="/transactions/TransactionForm" element={<TransactionForm />} />
                      <Route path="/transactions/SavingAccountTransaction" element={<SavingAccountTransaction />} />
                      <Route path="/transactions/RDDDAccountTransaction" element={<RDDDAccountTransaction />} />
                      <Route path="/transactions/RDDDPreClosure" element={<RDDDPreClosure />} />
                      <Route path="/transactions/RDDDEmiPay" element={<RDDDEmiPay />} />
                      <Route path="/transactions/RDDDManualPay" element={<RDDDManualPay />} />
                      <Route path="/transactions/TransactionReport" element={<TransactionReport />} />
                      <Route path="/Transaction/ViewStatement" element={<ViewStatement />} />


                      <Route path="/print/PrintStatement" element={<PrintStatement />} />
                      <Route path="/Print/LoanStatement/:loanId" element={<PrintLoanStatement />} />




                      <Route path="/Banking/OpenAccount/Saving" element={<Saving />} />
                      <Route path="/Banking/OpenAccount/RDACC" element={<RDACC />} />
                      <Route path="/Banking/OpenAccount/Current" element={<Current />} />
                      <Route path="/Banking/OpenAccount/Sanction/:loanId" element={<Sanction />} />
                      <Route path="/Banking/OpenAccount/CC" element={<CC />} />
                      <Route path="/Banking/OpenAccount/ApplyCC" element={<ApplyCC />} />
                      <Route path="/Banking/DepositAccount/Depositemireciept" element={<Depositemireciept />} />
                      <Route path="/Banking/DepositAccount/AlternatePaymentReceipt" element={<RDDDAlternatePayReceipt />} />
                      <Route path="/Banking/OpenAccount/Promises/:loanId" element={<Promises />} />
                      <Route path="/Banking/OpenAccount/Agreement/:loanId" element={<Agreement />} />

                      <Route path="/Banking/OpenAccount/PaySlip" element={<PaySlip />} />
                      <Route path="/Banking/Report/Demo" element={<Demo />} />
                      <Route path="/Banking/Scheme/Share" element={<Share />} />
                      <Route path="/Banking/Report/Bond" element={<Bond />} />
                      <Route path="/Banking/Report/SavingReport" element={<SavingReport />} />
                      <Route path="/Banking/Report/Verify" element={<Verify />} />
                      <Route path="/Banking/Report/DDReport" element={<DDReport />} />
                      <Route path="/Banking/Scheme/MISPayment" element={<MISPayment />} />
                      <Route path="/Banking/Report/Close" element={<Close />} />
                      <Route path="/Banking/Report/Log" element={<Log />} />




                      <Route path="/Banking/DepositAccount/FD" element={<FD />} />
                      <Route path="/Deposit/EmiDetails/:id" element={<DepositEmiList />} />
                      <Route path="/Banking/Report/AlternatePay/:id" element={<RDDDAlternatePayment />} />
                      <Route path="/Deposit/EmiDetails/Reciept" element={<Loanemireciept />} />


                      <Route path="/Banking/DepositAccount/RD" element={<RD />} />
                      <Route path="/Banking/DepositAccount/DD" element={<DD />} />
                      <Route path="/Banking/DepositAccount/MIS" element={<MIS />} />
                      <Route path="/Banking/Scheme/FDCertificate" element={<FDCertificate />} />
                      <Route path="/Banking/Scheme/SavingScheme" element={<SavingScheme />} />
                      <Route path="/Banking/Scheme/RDScheme" element={<RDScheme />} />
                      <Route path="/Banking/Scheme/FDScheme" element={<FDScheme />} />



                      <Route path="/Banking/Report/Verify" element={<Verify />} />
                      <Route path="/Banking/Report/Demo" element={<Demo />} />
                      <Route path="/Banking/Report/SavingCloserRequest" element={<SavingCloserRequest />} />
                      <Route path="/Banking/Report/RDReport" element={<RDReport />} />
                      <Route path="/Banking/Report/RDDDCloserRequest" element={<RDDDCloserRequest />} />
                      <Route path="/Banking/Report/DDReport" element={<DDReport />} />
                      <Route path="/Banking/Report/FDMISCloserRequest" element={<FDMISCloserRequest />} />
                      <Route path="/Banking/Report/FDReport" element={<FDReport />} />
                      <Route path="/Banking/Report/RDCertificates" element={<RDCertificates />} />
                      <Route path="/Banking/Report/FDCertificates" element={<FDCertificates />} />
                      <Route path="/Banking/Report/MisHistory" element={<MisHistory />} />
                      <Route path="/Banking/Report/DDCertificates" element={<DDCertificates />} />
                      <Route path="/Banking/Report/MisCertificates" element={<MisCertificates />} />
                      <Route path="/Banking/Report/DepositInstallmentDueReport" element={<DepositInstallmentDueReport />} />
                      <Route path="/Banking/Report/RDDDPassbook" element={<RDDDPassbook />} />

                      <Route path="/Banking/depositcollection" element={<DepositCollectionReport />} />
                      <Route path="/Banking/DepositCollectionReceipt/:loanId" element={<DepositCollectionReceipt />} />

                      <Route path="/Banking/Report/Membership" element={<Membership />} />
                      <Route path="/Banking/Report/CustomerCertificates" element={<CustomerCertificates />} />
                      <Route path="/Banking/Report/SharesCertificates" element={<SharesCertificates />} />
                      <Route path="/Banking/Report/SavingPassbook" element={<SavingPassbook />} />
                      <Route path="/Banking/Report/LoanStatement" element={<LoanStatement />} />



                      <Route path="/Banking/Scheme/RDScheme" element={<RDScheme />} />
                      <Route path="/Banking/Scheme/FDScheme" element={<FDScheme />} />
                      <Route path="/Banking/Scheme/SavingScheme" element={<SavingScheme />} />
                      <Route path="/Banking/Scheme/NewCC" element={<NewCC />} />
                      <Route path="/Banking/Scheme/NewsCC" element={<NewsCC />} />


                      <Route path="/Cibils/EquafixCibil" element={<EquafixCibil/>} />
                      <Route path="/Cibils/ExperianCibil" element={<ExperianCibil/>} />
                      <Route path="/Cibils/EquafixCibilReport" element={<CibilReport />} />


                    </Routes>
                  </div>
                </div>
              </div>
            }
          />
        ) : (
          // If not authenticated, redirect all to login
          <Route path="/*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </Router>
    </AuthProvider>
  );
}
